export const newPageNotificationModal = {
	title: "¡Más seguridad para tu fiscal!",
	content: "Ahora, siempre que un registro fiscal sea creado o modificado por Zig,",
	contentEmphasis:
		"podrás revisar y validar los datos antes de que sean utilizados.",
	primaryActionLabel: "Ver novedades",
};
